async function removeAuctionItemsFromCart() {
  const shopStore = 'zyzz-gear';
  const STOREFRONT_ACCESS_TOKEN = 'af63a5dfec8a27a303ff0e96ea3ffc58';
  const GRAPHQL_URL = `https://${shopStore}.myshopify.com/api/2024-04/graphql.json`;

  try {
    const cart = await fetch('/cart.js').then(res => res.json());

    if (!cart.items.length) return;

    const productIds = cart.items.map(item => `gid://shopify/Product/${item.product_id}`);

    const query = `
      query {
        nodes(ids: ${JSON.stringify(productIds)}) {
          ... on Product {
            id
            tags
          }
        }
      }
    `;

    const response = await fetch(GRAPHQL_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN
      },
      body: JSON.stringify({ query })
    });

    const result = await response.json();
    const productsWithTags = result.data.nodes;

    const auctionProductIds = productsWithTags
      .filter(p => p?.tags?.includes('product_auction'))
      .map(p => parseInt(p.id.split('/').pop()));

    const itemsToRemove = cart.items.filter(item =>
      auctionProductIds.includes(item.product_id)
    );

    if (itemsToRemove.length > 0) {
      for (const item of itemsToRemove) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        });
      }

      // Refresh the cart drawer silently
      setTimeout(() => {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      }, 200);
    }
  } catch (e) {
    console.error('Auction product removal failed:', e);
  }
}

// ✅ Run on page load
document.addEventListener('DOMContentLoaded', removeAuctionItemsFromCart);

// ✅ Also run instantly when anything is added to the cart
document.addEventListener('product:added', removeAuctionItemsFromCart);
